import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
    selector: 'app-recovery-payment-row',
    templateUrl: './recovery-payment-row.component.html',
    styleUrls: ['./../base-row.component.scss'],
    standalone: false
})
export class RecoveryPaymentRowComponent extends BaseRow {

}
